import script from "./ProjectMetricsSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMetricsSummary.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMetricsSummary.vue?vue&type=style&index=0&id=5254bbfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5254bbfa"]])

export default __exports__